import { Component, Input } from '@angular/core';
import { BundleDetails } from '@models/bundle-details.model';

@Component({
  selector: 'gc-bundle-display-card',
  templateUrl: './bundle-display-card.html',
  styleUrls: ['./bundle-display-card.scss'],
  standalone: false,
})
export class BundleDisplayCardComponent {
  @Input() bundle: BundleDetails;
}
